import React from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "#utils/spacing";
import * as styles from "./styles_vanilla.css";

type ComposeActionsProps = {
  onPostInternal: () => void;
  onReplyToClient: () => void;
  disabled?: boolean;
};

type ActionRowProps = {
  iconName: "sticky-note" | "share-all";
  title: string;
  subtitle: string;
  onClick: () => void;
  testId: string;
  disabled?: boolean;
};

const ActionRow: React.FC<ActionRowProps> = ({
  iconName,
  title,
  subtitle,
  onClick,
  testId,
  disabled,
}) => (
  <Button
    variant="neutral"
    className={styles.actionRow}
    onClick={onClick}
    data-testid={testId}
    disabled={disabled}
  >
    <Icon type={iconName} size="large" color={Colors.Neutral700} />
    <Flex flexDirection="column" gap={SPACING.X_SMALL} className={styles.actionRowContent}>
      <Text variant="strong-md" color={Colors.Neutral900}>
        {title}
      </Text>
      <Text variant="secondary-sm" color={Colors.Neutral600}>
        {subtitle}
      </Text>
    </Flex>
    <Icon type="chevron-right" size="medium" color={Colors.Neutral700} />
  </Button>
);

export const ComposeActions: React.FC<ComposeActionsProps> = ({
  onPostInternal,
  onReplyToClient,
  disabled,
}) => {
  return (
    <Flex
      flexDirection="column"
      gap={SPACING.LARGE}
      className={styles.composeActions}
      data-testid="workflow-comments-compose-actions"
    >
      <Text variant="strong-lg" color={Colors.Neutral900}>
        Who should see this comment?
      </Text>
      <ActionRow
        iconName="sticky-note"
        title="Post internal note"
        subtitle="Only visible to Canopy users"
        onClick={onPostInternal}
        testId="workflow-comments-post-internal-button"
        disabled={disabled}
      />
      <ActionRow
        iconName="share-all"
        title="Reply to client"
        subtitle="Visible to clients and Canopy users"
        onClick={onReplyToClient}
        testId="workflow-comments-reply-to-client-button"
        disabled={disabled}
      />
    </Flex>
  );
};
